import { Component, OnInit, OnDestroy, ElementRef, ViewChild, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { OrderService, AuthenticationService, ShipmentService, ScannerService } from '../../../services';

// import {  COMMENT, QUEUED, PRINTED, PREPRESS } from '../../../../ngrx/status-types';
// import {  SET_ORDER_DETAILS_VIEW, SET_JOB_DETAILS_VIEW } from '../../../../ngrx/actions';
import { BsModalService } from 'ngx-bootstrap';
import { TranslateService } from 'app/i18n';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SET_JOB_DETAILS_VIEW, SET_JOB_SHIP_FLAG, SET_SHIPMENT_DETAILS_VIEW } from 'ngrx/actions';
import { HOLD, SHIPMENTS, SHIPPING } from 'ngrx/status-types';
import { Subscription, Observable } from 'rxjs';
import { ActivityHistory } from 'app/models';

import { accessories } from 'ngrx/material-type';
import { Router } from '@angular/router';

@Component({
  selector: 'sheet-count-modal',
  templateUrl: 'sheet-count-modal.component.html',
  styleUrls:   ['sheet-count-modal.component.scss']
})
export class SheetCountModal implements OnInit, OnDestroy {
  @Input('job') job;
  @Input('order') order;
  @Input('shipment')     shipment;
  // process             : Observable<string>;
  errCount               : number;
  sheetEst               : string;
  numPages               : string;
  isAdmin                : boolean;
  isSupervisor           : boolean;
  sheetErr               : boolean;
  sheetErr2              : boolean;
  success                : boolean;
  jobIncomplete          : boolean;
  jobIncompleteErrMessage: string;
  jobIncompleteSheetEst  : string;
  initSubscriptions      : Subscription[];
  jobShipFlagView        : Observable<any>;
  jobShipFlag            : boolean;

  constructor(
    private authService      : AuthenticationService,
    private orderService     : OrderService,
    private router           : Router,
    private shipmentService  : ShipmentService,
    // private fb               : FormBuilder,
    private store            : Store<any>,
    private translate        : TranslateService,
    private modalService     : BsModalService,
    // private scanner          : ScannerService
  ) {
    this.jobShipFlagView          = this.store.select('jobs', 'jobShipFlagView');
    // this.process         = this.authService.getCurrentProcess();
    // this.isAdmin         = this.authService.userIsAdmin();
    // this.accessories     = accessories;
  }
  
  ngOnInit(): void {
    console.log(this.job.product)

    // console.log('job from sheetcount : ', this.job)
    // console.log('order from sheetcount : ', this.order)
    // console.log('shipment from sheetcount : ', this.shipment)

    this.sheetEst = '';
    this.jobIncompleteSheetEst = '';
    this.numPages = this.job.qty + '';
    this.errCount = 0;

    this.initSubscriptions = [
      this.jobShipFlagView
      .take(1)
      .subscribe( (jobShipFlagState) => {
        const { shipFlag } = jobShipFlagState;
  
        console.log('Store JobShip flag : ',shipFlag)
        this.jobShipFlag = shipFlag;
      })
    ]

  }

  ngOnDestroy(): void {
    console.log("Destroying...");
    this.errCount = 0;
    this.initSubscriptions.forEach(subscription => subscription.unsubscribe());
  }

  isNumberKey(event) {
    console.log("test",event)
    // if(this.sheetEst && this.sheetEst.toString().length > 6) {
    //   this.sheetEst = this.sheetEst.toString().slice(1, 7);
    // }
    this.addSheet('')
  }

  addSheet(num) {
    this.sheetEst = (this.sheetEst == null ? '' : this.sheetEst) + num;
    if(this.sheetEst && this.sheetEst.length > 6) {
      console.log("slice");
      this.sheetEst = this.sheetEst.slice(1, 7);
      console.log("slice",this.sheetEst);
    }
    console.log(this.sheetEst)
    if(!this.jobIncomplete) {
      if(this.sheetEst[0] === this.numPages[0]) {
        //first number is correct
        if(this.sheetEst === this.numPages) {
          this.success = true;
          this.sheetErr2 = false;
          this.sheetErr = false
          console.log("Updating job to shipment status");
          this.store.dispatch({
            type   : SET_JOB_DETAILS_VIEW,
            payload: { loading: true }
          });

          /*
            If more than one job set flag to prevent double shipment
            else update as usual
          */
          if(this.order && this.order.jobs.length > 1 && !this.shipment){ //More than one jobs and no shipment
            if(!this.jobShipFlag){
              this.orderService.setJobStatus(this.job, SHIPMENTS);
            }

            this.store.dispatch({
              type   : SET_JOB_SHIP_FLAG,
              payload: { shipFlag: true }
            }); 
          }else{
            this.orderService.setJobStatus(this.job, SHIPMENTS);
          }        
          setTimeout(()=> {
              this.modalService.hide(1)
          }, 2000);
          return;
        } else if (this.sheetEst[this.sheetEst.length - 1] != this.numPages[this.sheetEst.length - 1]) {
          console.log("last number inputted is wrong")
          this.errCount++
          console.log(this.errCount);
          this.jobIncompleteSheetEst = this.sheetEst;
          if(this.errCount <= 1) {
            this.sheetErr = true;
          } else {
            this.sheetErr = false;
            this.sheetErr2 = true;
          }
          setTimeout(() => this.sheetEst = "", 2000);
          
          this.success = false;
        } else {
          this.jobIncompleteSheetEst = this.sheetEst;
          setTimeout(() => this.sheetEst = "", 2000);
          setTimeout(() => this.sheetErr = true, 2000);
        }
      } else {
        this.success = false;
        this.errCount++;
        this.jobIncompleteSheetEst = this.sheetEst;
        console.log(this.errCount)
        if(this.errCount <= 1) {
          this.sheetErr = true;
          setTimeout(() => this.sheetEst = "", 2000);
        } else {
          this.sheetErr = false;
          this.sheetErr2 = true;
          setTimeout(() => this.sheetEst = "", 2000);
        }
      }
    }
  }

  incompleteJob() {
    this.jobIncomplete = true;
    this.router.navigate(['dashboard/jobs', HOLD, this.job.id]);
    const missingSheets = Number(this.jobIncompleteSheetEst) > Number(this.numPages) 
                          ? Number(this.jobIncompleteSheetEst) - Number(this.numPages) + ' sheets extra' 
                          :  Number(this.numPages) - Number(this.jobIncompleteSheetEst) + ' sheets missing';
    this.store.dispatch({
      type   : SET_JOB_DETAILS_VIEW,
      payload: { loading: true }
    });
    this.orderService.setJobStatus(this.job, HOLD, SHIPPING, false, missingSheets);
    this.jobIncompleteErrMessage = Number(this.jobIncompleteSheetEst) > Number(this.numPages) 
                                  ? this.translate.instant('SHEET_INCORRECT_QTY_MISSING',[(Number(this.jobIncompleteSheetEst) - Number(this.numPages)).toString()]) 
                                  : this.translate.instant('SHEET_INCORRECT_QTY_EXTRA',[(Number(this.numPages) - Number(this.jobIncompleteSheetEst)).toString()])
  }


 }



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/modals/sheet-count-modal/sheet-count-modal.component.ts